import { Route } from "react-router-dom";

export default ({ Component, cProps, ...rest }) => {
  return (
    <Route {...rest} render={(props) => <Component {...props} {...cProps} />} />
  );
};
